module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-76x76-23d3d291392f095090094ebc2f755b22.png";